module.exports = __webpack_public_path__ + "Icon_Specialities.9f41ec641b498683c62c.png";